export default [
  {
    path: '/educational',
    component: () => import('@/views/layout/index.vue'),
    redirect: '/course',
    children: [
      {
        path: 'materials',
        name: 'materials',
        component: () => import('@/views/educational/materials/index.vue'),
        meta: {
          title: '教务管理/教材信息',
          keepAlive: true
        }
      },
      {
        path: 'course',
        name: 'course',
        component: () => import('@/views/educational/course/index.vue'),
        meta: {
          title: '教务管理/班级信息',
          keepAlive: true
        }
      },
      {
        path: 'course-detail/:id',
        name: 'course-detail',
        component: () => import('@/views/educational/course/detail.vue'),
        meta: {
          title: '教务管理/班级详情',
          keepAlive: true
        }
      },

      {
        path: 'lesson-detail/:id',
        name: 'lesson-detail',
        component: () => import('@/views/educational/course/lesson.vue'),
        meta: {
          title: '教务管理/课时详情',
          keepAlive: true
        }
      },
      {
        path: 'teaching',
        name: 'teaching',
        component: () => import('@/views/educational/teaching/index.vue'),
        meta: {
          title: '教务管理/上课信息',
          keepAlive: true
        }
      }
    ]
  }
]
